import React from 'react'
import { useDarkmodeContext } from '../contexts/DarkmodeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

function DarkmodeButton() {
    const { darkMode, handleDarkmode } = useDarkmodeContext()

    return (
        <button
            style={{
                color: darkMode ? 'white' : '#222',
                borderColor: darkMode ? 'white' : '#222'
            }}
            className='themeBtn'
            onClick={handleDarkmode}
            title='switch theme'
        >
            {!darkMode ?
                <FontAwesomeIcon icon={faSun} style={{
                    fontSize: "24px",
                    boxShadow: '0 2px 5px rgba(255, 101, 47, .2)',
                    borderRadius: '100px',
                    padding: "2px"
                }} />
                :
                <FontAwesomeIcon icon={faMoon} style={{
                    fontSize: "24px",
                    boxShadow: '0 2px 5px rgba(255, 101, 47, .2)',
                    borderRadius: '100px',
                    padding: "2px"
                }} />
            }

        </button>
    )
}

export default DarkmodeButton;
